import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'booleanConverter'
})
export class BooleanConverterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    value = String(value);
    if (value && value.search(/^true|false$/i) > -1) {
      return value.search(/^true$/) > -1 ? 'YES' : 'NO';
    }
    return value;
  }

}
